module.exports = __webpack_public_path__ + "img/service4.f45b608f.png";